__webpack_require__.p = "/minimalist_portfolio/";